
















































import OverlayMixin from '@/mixins/overlays'
import mixins from 'vue-typed-mixins'
import ContentBlockerDetected from '@components/modals/ContentBlockerDetected.vue'
import StoreBanner from '@components/StoreBanner.vue'
import WrappedLink from '@components/WrappedLink.vue'
import { isIOS, isAndroid } from 'mobile-device-detect'

export default mixins(OverlayMixin).extend({
  name: 'Index',
  components: {
    ContentBlockerDetected,
    StoreBanner,
    WrappedLink
  },
  computed: {
    isContentBlocked () {
      return !this.$store.getters['app/isBranchAvailable']
    },
    isExpired () {
      const userId = this.$store.getters['user/userId']
      const credentials = this.$store.getters['user/credentials']
      return !userId && credentials
    },
    platformType () {
      return JSON.stringify({ isIOS, isAndroid }, null, 2)
    },
    isMobile () {
      return isIOS || isAndroid
    }
  },
  async mounted () {
    await this.evalLinkStatus()
  },
  methods: {
    async evalLinkStatus () {
      if (this.isExpired && !this.isMobile) {
        await this.showModal(
          this.$t('userMessages.linkExpiration.message'),
          {
            title: this.$t('userMessages.linkExpiration.title')
          }
        )
      }
    }
  }
})
